import {
  UniFiCategoryId,
  UniFiChildCategorySlug,
} from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/wifi/flagship/u7-pro-xg.png";
import { type Product } from "../../types";
import { wifiFlagship } from "../product-list-groups/wifi-flagship";
import {
  connectedDevices,
  dimensions,
  radio6Ghz,
  uplink,
  wifiCoverage,
  wifiTechnology,
} from "../properties";

export const u7proXg: Product = {
  id: "u7proXg",
  productTitle: "U7 Pro XG",
  description: "u7proXg.description",
  storePathParts: {
    category: UniFiChildCategorySlug.WiFiFlagship,
    productSlug: "u7-pro-xg",
  },
  techspecsPath: [SiteId.TechSpecs, `/unifi/${UniFiCategoryId.WiFi}/u7-pro-xg`],
  image: { src: image, width: 200, height: 160 },
  productListGroup: wifiFlagship,
  isNew: true,
  propertyValues: [
    {
      propertyId: dimensions.id,
      value: {
        type: "translation",
        value: "u7proXg.dimensions",
      },
    },
    {
      propertyId: wifiTechnology.id,
      value: {
        type: "translation",
        value: "u7proXg.wifiTechnology",
      },
    },
    {
      propertyId: radio6Ghz.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: wifiCoverage.id,
      value: { type: "string", value: "140 m² (1,500 ft²)" },
    },
    {
      propertyId: connectedDevices.id,
      value: {
        type: "string",
        value: "300+",
      },
    },
    {
      propertyId: "powerMethodPoe",
      value: {
        type: "string",
        value: "PoE+",
      },
    },
    {
      propertyId: uplink.id,
      value: {
        type: "translation",
        value: "u7proXg.uplink",
      },
    },
    {
      propertyId: "radios",
      value: {
        type: "boolean",
        value: false,
      },
    },
    // MUST HAVE FOR OVERVIEW SECTION
    {
      propertyId: "extendedRangeMode6Ghz",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "rfFilteringTechnology",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "antennaType",
      value: {
        type: "translation",
        value: "antennaType.omnidirectional",
      },
    },
    {
      propertyId: "weatherproofing",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "redundantRj45Port",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "wifiMounting",
      value: {
        type: "translation",
        value: "commons.mounting.ceilingWall",
      },
    },
  ],
};
